import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const DigigoCallback = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  
  // ??? Protection contre le double appel en React Strict Mode (Dev)
  const hasFetched = useRef(false);

  useEffect(() => {
    // Si d�j� ex�cut�, on arr�te tout de suite
    if (hasFetched.current) return;
    hasFetched.current = true;

    const processCallback = async () => {
      try {
        console.log("DIGIGO CALLBACK URL =>", window.location.href);

        // =========================================================
        // 1) R�cup�ration des param�tres
        // =========================================================
        const code = searchParams.get('code');        
        const token = searchParams.get('token'); 
        const sad = searchParams.get('sad');      
        let invoiceId = searchParams.get('state');

        // Fallback LocalStorage si le state est perdu
        if (!invoiceId || invoiceId === 'null') {
          console.log("?? ID manquant dans l'URL, tentative LocalStorage...");
          invoiceId = localStorage.getItem('pendingInvoiceId');
        }

        // ? RECUPERATION CRITIQUE DE L'HEURE DE SIGNATURE
        const signingTime = localStorage.getItem('signingTime');
        if (!signingTime) {
            console.warn("?? ATTENTION : signingTime introuvable dans le localStorage. La signature risque d'�chouer.");
        }

        // La preuve unique (Code, Token ou SAD)
        const proof = code || token || sad;

        console.log("?? Param�tres extraits:", { invoiceId, proofFound: !!proof, signingTime });

        // V�rifications
        if (!proof) {
          setStatus('error');
          setMessage("Erreur: Aucun code d'autorisation re�u de DigiGo.");
          return;
        }

        if (!invoiceId) {
          setStatus('error');
          setMessage("Erreur: Impossible d'identifier la facture (ID manquant).");
          return;
        }

        // =========================================================
        // 2) Appel au Backend
        // =========================================================
        const jwt = localStorage.getItem('token');
        
        // Utilisation de l'URL dynamique selon l'environnement
        const baseUrl = process.env.REACT_APP_API_URL || 'https://app.accountintime.tn';
        const apiUrl = `${baseUrl}/api/digigo/validate-callback`;

        console.log("?? Envoi au backend:", apiUrl);

        const response = await axios.post(
          apiUrl,
          {
            invoiceId,
            // ?? CRITIQUE : On mappe 'proof' vers 'token' ou 'code'
            code: code, // Si c'est un flux code
            token: proof, // Fallback g�n�rique
            signingTime: signingTime, // ? ENVOI DE L'HEURE FIG�E AU BACKEND
            origin: 'web-callback'
          },
          {
            headers: {
              'Content-Type': 'application/json',
              ...(jwt ? { Authorization: `Bearer ${jwt}` } : {})
            }
          }
        );

        // =========================================================
        // 3) Gestion R�ponse
        // =========================================================
        if (response.data && response.data.success) {
          setStatus('success');
          setMessage(response.data.message || 'Signature valid�e avec succ�s !');

          // Nettoyage complet
          localStorage.removeItem('pendingInvoiceId');
          localStorage.removeItem('signingTime'); // ? Nettoyage de l'heure

          // Redirection apr�s 2 secondes
          setTimeout(() => {
            window.location.href = '/invoices'; 
          }, 2000);

        } else {
          throw new Error(response.data?.message || 'R�ponse non-succ�s du serveur');
        }

      } catch (error) {
        console.error("? Erreur Callback:", error);
        
        const errorMsg = 
          error.response?.data?.message || 
          error.response?.data?.error || 
          error.message || 
          "Erreur inconnue lors de la validation.";

        setStatus('error');
        setMessage(errorMsg);
      }
    };

    processCallback();
    
  }, [searchParams]);

  const handleReturn = () => {
    window.location.href = '/invoices';
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px', padding: '20px', fontFamily: 'sans-serif' }}>
      {status === 'loading' && (
        <div>
          <h2 style={{ color: '#0056b3' }}>?? Communication avec DigiGo...</h2>
          <p>V�rification de la signature en cours, veuillez patienter.</p>
          <div className="spinner" style={{ margin: '20px auto', width: '40px', height: '40px', border: '4px solid #f3f3f3', borderTop: '4px solid #0056b3', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
          <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        </div>
      )}
      
      {status === 'success' && (
        <div>
          <h2 style={{ color: 'green' }}>? Succ�s !</h2>
          <p style={{ fontSize: '18px' }}>{message}</p>
          <p style={{ color: '#666' }}>Redirection vers les factures...</p>
        </div>
      )}

      {status === 'error' && (
        <div>
          <h2 style={{ color: '#d32f2f' }}>? �chec de la signature</h2>
          <p style={{ background: '#fff0f0', padding: '15px', borderRadius: '5px', display: 'inline-block', color: '#d32f2f' }}>
            {message}
          </p>
          <br />
          <button
            onClick={handleReturn}
            style={{
              marginTop: '20px',
              padding: '10px 25px',
              background: '#333',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Retour aux factures
          </button>
        </div>
      )}
    </div>
  );
};

export default DigigoCallback;